import React from 'react';
import { useSEO } from '@/hooks/useSEO';
import { PageHero } from '@/pages/About';
import { useLanguage } from '@/contexts/LanguageContext';

const HERO = 'https://images.unsplash.com/photo-1448630360428-65456885c650?w=2000&q=80&auto=format&fit=crop';

const RealEstate = () => {
  const { t } = useLanguage();
  useSEO({ title: 'Nekilnojamasis turtas ir statyba — UAB MAIŠIAGALA GROUP', description: 'Pilno ciklo nekilnojamojo turto plėtra Lietuvoje: statyba, rekonstrukcija, projektų valdymas.', path: '/real-estate' });
  const services = t('realestate.services') || [];

  return (
    <div data-testid="realestate-page">
      <PageHero title={t('realestate.title')} image={HERO} />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <p className="text-white/60 max-w-2xl text-lg mb-16">{t('realestate.lead')}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#262626]">
          {services.map((s, i) => (
            <div
              key={i}
              className="bg-[#0A0A0A] p-10 md:p-14 hover:bg-[#141414] transition-colors duration-500 group"
              data-testid={`re-service-${i}`}
            >
              <div className="text-gold font-serif text-2xl mb-6">0{i + 1}</div>
              <h3 className="font-serif text-white text-2xl tracking-tight mb-3 group-hover:text-gold transition-colors">
                {s.t}
              </h3>
              <p className="text-white/60 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default RealEstate;
